import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import axios from "axios";
import API_BASE from "../../config";

export const fetchSubscriptionStatus = createAsyncThunk("subscription/status", async () => {
  const response = await api.get("/subscriptions/status");
  return response.data;
});

export const fetchTiers = createAsyncThunk("subscription/tiers", async () => {
  const response = await axios.get(`${API_BASE}/subscriptions/tiers`);
  return response.data;
});

export const createCheckout = createAsyncThunk("subscription/checkout", async ({ tier, billing }) => {
  const response = await api.post("/subscriptions/create-checkout", { tier, billing });
  return response.data;
});

export const openBillingPortal = createAsyncThunk("subscription/billingPortal", async () => {
  const response = await api.post("/subscriptions/billing-portal");
  return response.data;
});

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    status: null,
    tiers: [],
    isInTrial: false,
    canSendQuote: true,
    quotesUsed: 0,
    quotesLimit: 0,
    fetchStatus: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionStatus.pending, (state) => { state.fetchStatus = "loading"; })
      .addCase(fetchSubscriptionStatus.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.status = action.payload;
        state.isInTrial = action.payload.isInTrial;
        state.canSendQuote = action.payload.canSendQuote;
        state.quotesUsed = action.payload.quotesUsed;
        state.quotesLimit = action.payload.quotesLimit;
      })
      .addCase(fetchTiers.fulfilled, (state, action) => {
        state.tiers = action.payload.tiers;
      })
      .addCase(createCheckout.fulfilled, (state, action) => {
        if (action.payload.url) {
          window.location.href = action.payload.url;
        }
      })
      .addCase(openBillingPortal.fulfilled, (state, action) => {
        if (action.payload.url) {
          window.location.href = action.payload.url;
        }
      });
  },
});

export default subscriptionSlice.reducer;
